import { render, staticRenderFns } from "./static-action.vue?vue&type=template&id=6472480f&scoped=true"
import script from "./static-action.vue?vue&type=script&lang=js"
export * from "./static-action.vue?vue&type=script&lang=js"
import style0 from "./static-action.vue?vue&type=style&index=0&id=6472480f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6472480f",
  null
  
)

export default component.exports